module.exports = {"House1":{"daobanList":[{"title":"1:是否申领居住证","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、居住证-申领居住证","state":"必要"},{"name":"2、《广东省居住证业务申请表》","state":"必要"},{"name":"3、本人居民身份证或者其它有效身份证明原件及复印件","state":"必要"},{"name":"4、监护人、近亲属代为办理的，应当提供委托人、代办人的合法有效身份证明原件及复印件、本人居住证相片回执、根据申请事由分别提供合法稳定就业，合法稳定住所，连续就读证明等原件及复印件。","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdh-1.json
// module id = 1257
// module chunks = 0